import React from 'react'

const DateInput = React.forwardRef(({ value, onClick }, ref) => (
  <span className='line-bordered selected-date' onClick={onClick} ref={ref}>
    {moment(new Date(value)).format("dddd, MMMM Do YYYY")}
  </span>
));

export default DateInput
